import { render, staticRenderFns } from "./UrunlerInfo.vue?vue&type=template&id=aba6f2b6&scoped=true"
import script from "./UrunlerInfo.vue?vue&type=script&lang=ts"
export * from "./UrunlerInfo.vue?vue&type=script&lang=ts"
import style0 from "./UrunlerInfo.vue?vue&type=style&index=0&id=aba6f2b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba6f2b6",
  null
  
)

export default component.exports